import React, { Fragment, useState } from "react";
import SideBar from "./SideBar";
import NavHader from "./NavHader";
import Header from "./Header";

const JobieNav = ({ path }) => {
  return (
    <Fragment>
      <NavHader />
      <Header
        path={path}
      />
      <SideBar />
    </Fragment>
  );
};

export default JobieNav;
